export enum SessionExpiredReason {
  IpChanged = 'ip_changed',
}
